import { DynamicTableWidgetDetailsM } from './../../../modules/shared/models/dynamic-table/dynamic-table-widget-details.model';
import { DynamicTableWidgetService } from './../../../modules/shared/services/dynamic-table/dynamic-table-widget.service';
import { StoreService } from './../../../modules/shared/services/store.service';
import { LEAD_ID } from '../../../contacts/contacts.constant';
import { ActivityService } from 'src/app/shared/shared-activities/activity.service';
import { AppMainService } from '../../../app-main.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppMainComponent } from '../../../app.main.component';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { LeadModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { SharedChannelService } from 'src/app/modules/shared/services/channel.service';
import { ChannelN } from 'src/app/modules/shared/models/channel.model';
import { LeadViewTabIndex, LeadViewTabIndexWithContact } from '../../model/lead-tab-change.enum';
import { FormControlList } from '../../../modules/shared/constants/formcontrol-list.constants';
import { take } from 'rxjs';
import { PHONE_TYPE_IDS } from 'src/app/modules/shared/constants/typeId';

@Component({
  selector: 'app-leads-full-details',
  templateUrl: './leads-full-details.component.html',
  styleUrls: ['./leads-full-details.component.scss']
})
export class LeadsFullDetailsComponent implements OnInit, OnChanges {

    @Input() hideAddEdit = false;
    @Input() configMenuItems;
    @Input() selectedChannelInfo;
    @Output() openLeadContextMenu = new EventEmitter;
    @Output() detailsCancelClicked = new EventEmitter;
    taskFromModule:boolean = false
    @Output() hideFloathead = new EventEmitter();
    @Output() showFloathead = new EventEmitter();

    @Output() tabhandleChange = new EventEmitter;
    @Input() selectedTabIndex = 0;
    @Input() leadStages;
    @Input() curIndex;
    @Input() closedStages;
    @Input() editPermission;
    @Output() openUpdateStagePopup = new EventEmitter;
    @Input() isMenuShow;
    @Input() isLeftTableHide: boolean = false;
    @Output() hideMenu = new EventEmitter;
    @Output() showMenu = new EventEmitter;
    @Output() reloadDetails = new EventEmitter<any>();
    @Input() savedLeadListDetailCols;
    @Input() filteredLeads;
    @Input() qualifiedId;

    @Input() selectedLeadFromTable;
    @Input() selectedLead;
    @Input() leadContacts;
    @Output() onCommentSaved = new EventEmitter;

    @Input() contactModulePermission;
    @Output() getLeadDetailsForLeadContacts = new EventEmitter;
    @Output() postContactEdit = new EventEmitter;
    @Input() addUpdateDone;
    @Output() addLeadContact = new EventEmitter;
    @Input() leadsData;
    selectedChannel:ChannelN;
    leadModuleId = LeadModuleId;
    contactAssociationId = LEAD_ID;

    displayTaskAdd = false;
    objectTypeId = 1;
    objectId = 0;

    leadDocumentCheck:boolean = Boolean(false);
    leadViewTabIndex:any;

    allTabList: DynamicTableWidgetDetailsM[]
    tabList: DynamicTableWidgetDetailsM[] = [];
    subTabList: DynamicTableWidgetDetailsM[] = [];
    activeTabIndex: number = -1;
    activeSubtabIndex: number = -1;

    constructor(
        public app: AppMainComponent,
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private activityService: ActivityService,
        private appMainService: AppMainService,
        private sharedChannelService: SharedChannelService,
        private storeService: StoreService,
        private dynamicTableWidgetService: DynamicTableWidgetService
    ) { }

    ngOnInit(): void {
        if(this.contactModulePermission){
            this.leadViewTabIndex = LeadViewTabIndex;
        }else{
            this.leadViewTabIndex = LeadViewTabIndexWithContact;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.leadStages?.currentValue) {
            this.leadStages = this.leadStages.filter(stage => stage.id);
        }
        if(changes?.filteredLeads?.currentValue){
            this.activeSubtabIndex = -1;
            this.activeTabIndex = -1;
            this.gettabList();
            this.getChannels();
        }
    }

    openLeadMenu() {
        this.openLeadContextMenu.emit();
    }

    cancelLeadDetail() {
        this.detailsCancelClicked.emit();

    }

    changeTab(e){
        var index = e.index;
        this.selectedTabIndex = index;
        this.app.objectId = this.selectedLead.id;
        this.app.objectType = "Lead";
        this.tabhandleChange.emit(e);
    }

    getClosedStage(id){
        return this.closedStages.find(x => x.id == id) ? -1 : id;
    }

    openUpdateStagePopupChild(id, type){
        this.openUpdateStagePopup.emit({id, type});
    }

    onCommentSavedChild(e){
        this.onCommentSaved.emit(e);
    }

    getLeadDetails(e){
        this.getLeadDetailsForLeadContacts.emit(e);
    }

    postContactEditChild(e){
        this.postContactEdit.emit(e);
    }

    addLeadContactChild(e){
        this.addLeadContact.emit(e);
    }

    openAddTaskDialog() {
        this.displayTaskAdd = true;
        this.taskFromModule = true;
        this.objectTypeId = 1;
        this.objectId = this.selectedLead.id;
    }

    createComplete(event) {
        this.displayTaskAdd = false;
        this.onAddTask({ taskAdded: true });
    }

    cancelTaskAdd() {
        this.displayTaskAdd = false;
    }

    onAddTask(event) {
        if (event.taskAdded) {
            let objectTypeId = this.app.allObjects.filter(elem => elem.name === this.app.objectType)[0].type;
            this.activityService.getAllObjectTasks(this.app.objectId,objectTypeId,this.selectedLead?.leadStageId,this.selectedLead?.typeId).then((tasks: Array<any>) => {
                    this.storeService.setTaskList(tasks);
                    this.displayTaskAdd = false;
                });
        } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving data...' });
        }
    }

    getChannels(){
        this.appMainService.isShowSpinner('getChannelDataList');
        this.sharedChannelService.getChannels(this.leadModuleId).subscribe({
            next:(data:ChannelN[])=>{
              this.selectedChannel =  data.find((item:ChannelN)=>{
                    return item?.id == this.filteredLeads?.typeId
                });
                this.appMainService.isHideSpinner('getChannelDataList');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getChannelDataList');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error!',
                    detail: 'Error occurring when loading accounts. Please try after sometime.'
                });
            },
        })
    }
    menuShow(type: 'menu'|'table'){
        this.hideFloathead.emit();
        this.showMenu.emit(type);
        if(type == "menu"){
            setTimeout(()=>{
                this.showFloathead.emit();
            }, 100);
        }
    }
    menuHide(type: 'menu'|'table'){
        this.hideFloathead.emit();
        this.hideMenu.emit(type);
        if(type == "menu"){
            setTimeout(()=>{
              this.showFloathead.emit();
            }, 100);
        }
    }

    reloadLeadDetails($event){
        this.reloadDetails.emit($event);
    }

    //#region dynamic tab list

    gettabList() {
        if (this.tabList?.length || this.subTabList?.length) {
          this.filterTabAndSubTabList();
          return;
        }
        this.dynamicTableWidgetService.getWidgets(LeadModuleId, this.filteredLeads?.typeId).pipe(take(1)).subscribe({
          next: (response) => {
            this.allTabList = response || [];
            this.filterTabAndSubTabList();
          },
          error: (error) => {
    
          }
        })
      }

      
  filterTabAndSubTabList() {
    this.getTabListFilterValues(this.allTabList);
    this.tabList = this.allTabList.filter(t => t.widgetType == 'Tab');
    this.subTabList = this.allTabList.filter(t => t.widgetType == 'Sublist');
  }

    getTabListFilterValues(allTabList: DynamicTableWidgetDetailsM[]) {
        allTabList.map(tab => {
            const moduleColumn = this.savedLeadListDetailCols.find(col => col?.id == tab.associationFieldId);
            let values: string[] = [];

            if (moduleColumn?.columnName && this.filteredLeads[moduleColumn.columnName]) {
                if ([FormControlList.MultipleDropDownList, FormControlList.CheckBox].includes(moduleColumn.formControlType) && moduleColumn.columnName !== 'tags') {
                    const splitedValues = this.filteredLeads[moduleColumn.columnName].split(",");
                    splitedValues?.map(v => values.push(v.trim()));
                }
                else if (moduleColumn.columnName === 'currencyName') {
                    if (this.filteredLeads?.currencyName) {
                        const currencyUnit = this.filteredLeads?.currencyUnit;
                        const currencyValue = `${currencyUnit.name} - ${currencyUnit.code}`;
                        values.push(currencyValue);
                    }
                }
                else if (moduleColumn.columnName === 'tags') {
                    const tags = this.filteredLeads[moduleColumn.columnName];
                    if (tags.length) {
                        tags.forEach(tag => {
                            if (tag.name) {
                                values.push(tag.name);
                            }
                        });
                    }
                }
                else if (moduleColumn.columnName === 'contactphonework') {
                    if (this.filteredLeads?.leadContacts && this.filteredLeads?.leadContacts?.length > 0) {
                        this.filteredLeads?.leadContacts?.forEach(leadContact => {
                            leadContact?.contact?.contactPhones?.forEach(contactDetails => {
                                if (contactDetails.phone.phoneTypeId == PHONE_TYPE_IDS.WORK) {
                                    const phoneNumber = contactDetails?.phone?.code ? `${contactDetails.phone.code}${contactDetails.phone.number}` : `${contactDetails.phone.number}`;
                                    values.push(phoneNumber);
                                }
                            });
                        });
                    }
                }
                else if (moduleColumn.columnName === 'contactphonemobile') {
                    if (this.filteredLeads?.leadContacts && this.filteredLeads?.leadContacts?.length > 0) {
                        this.filteredLeads?.leadContacts?.forEach(leadContact => {
                            leadContact?.contact?.contactPhones?.forEach(contactDetails => {
                                if (contactDetails.phone.phoneTypeId == PHONE_TYPE_IDS.MOBILE) {
                                    const phoneNumber = contactDetails?.phone?.code ? `${contactDetails.phone.code}${contactDetails.phone.number}` : `${contactDetails.phone.number}`;
                                    values.push(phoneNumber);
                                }
                            });
                        });
                        
                    }
                }
                else if (moduleColumn.columnName === 'contactphonehome') {
                    if (this.filteredLeads?.leadContacts && this.filteredLeads?.leadContacts?.length > 0) {
                        this.filteredLeads?.leadContacts?.forEach(leadContact => {
                            leadContact?.contact?.contactPhones?.forEach(contactDetails => {
                                if (contactDetails?.phone.phoneTypeId == PHONE_TYPE_IDS.HOME) {
                                    const phoneNumber = contactDetails?.phone?.code ? `${contactDetails.phone.code}${contactDetails.phone.number}` : `${contactDetails.phone.number}`;
                                    values.push(phoneNumber);
                                }
                            });
                        });;
                    }
                }
                else if (moduleColumn.columnName === 'contactphonecp1') {
                    if (this.filteredLeads?.leadContacts && this.filteredLeads?.leadContacts?.length > 0) {
                        this.filteredLeads?.leadContacts?.forEach(leadContact => {
                            leadContact?.contact?.contactPhones?.forEach(contactDetails => {
                                if (contactDetails?.phone.phoneTypeId == PHONE_TYPE_IDS.CP1) {
                                    const phoneNumber = contactDetails?.phone?.code ? `${contactDetails.phone.code}${contactDetails.phone.number}` : `${contactDetails.phone.number}`;
                                    values.push(phoneNumber);
                                }
                            });
                        });
                    }
                }
                else if (moduleColumn.columnName === 'contactphonecp2') {
                    if (this.filteredLeads?.leadContacts && this.filteredLeads?.leadContacts?.length > 0) {
                        this.filteredLeads?.leadContacts?.forEach(leadContact => {
                            leadContact?.contact?.contactPhones?.forEach(contactDetails => {
                                if (contactDetails.phone.phoneTypeId == PHONE_TYPE_IDS.CP2) {
                                    const phoneNumber = contactDetails?.phone?.code ? `${contactDetails.phone.code}${contactDetails.phone.number}` : `${contactDetails.phone.number}`;
                                    values.push(phoneNumber);
                                }
                            });
                        });
                    }
                }
                else {
                    values.push(this.filteredLeads[moduleColumn.columnName]);
                }
            }

            tab.associationFieldDetails = moduleColumn;
            tab.values = values;
        });
    }

    selectSubTab(index: number){
        this.activeTabIndex = index;
    }

    deleteSublist(sublistDetails: DynamicTableWidgetDetailsM) {
        this.confirmationService.confirm({
            message: 'Do you want to remove this Tab?',
            header: 'Remove Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.dynamicTableWidgetService.deleteWidget(sublistDetails.widgetId).subscribe({
                    next: (response)=>{
                        this.tabList = this.tabList.filter(t=> t.widgetId!==sublistDetails.widgetId);
                        this.selectedTabIndex = 0;
                        this.activeSubtabIndex = -1;
                        this.appMainService.hideAllSpinner();
                        this.messageService.add({ severity: 'success', summary: 'Tab Removed', detail: 'Tab removed successfully!' });
                    },
                    error: (error)=>{
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving data...' });
                    }
                })
            },
            reject: () => {
            }
        });
    }

    //#endregion dynamic tab list
}
